import { Config } from "@config";
import { AbstractStep } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { faArrowRight as fasArrowRight } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, FormIncomeSimple } from "bm-ui-kit";
import type { ReactNode } from "react";
import React from "react";
import { Card } from "react-bootstrap";

export class Step2 extends AbstractStep {
	protected renderContent(): ReactNode {
		return (
			<>
				<Card.Body>
					<FormIncomeSimple
						name="incomeList"
						apiAddress={Config.getApiUrl("/api/public/bank/loan/personal-loan/income-types")}
						size="sm"
						validate={FormIncomeSimple.validateIncomeList}
						withReceiptAmount
						withIncomeStart
						required
					/>
				</Card.Body>
				<Card.Footer className="text-center">
					<Button type="submit" icon={<FontAwesomeIcon icon={fasArrowRight} />}>
						Tovább
					</Button>
				</Card.Footer>
			</>
		);
	}

	protected getComponentName(): string {
		return "Step2";
	}
}
